var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinentEuropeCountrynetherland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1900_45944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.33325H24V14.6666H0V9.33325Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 3.33325H2.66667C1.95942 3.33325 1.28115 3.6142 0.781049 4.1143C0.280952 4.6144 0 5.29267 0 5.99992L0 9.33325H24V5.99992C24 5.29267 23.719 4.6144 23.219 4.1143C22.7189 3.6142 22.0406 3.33325 21.3333 3.33325Z",
    fill: "#AE1F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 20.6667H21.3333C22.0406 20.6667 22.7189 20.3858 23.219 19.8857C23.719 19.3856 24 18.7073 24 18.0001V14.6667H0V18.0001C0 18.7073 0.280952 19.3856 0.781049 19.8857C1.28115 20.3858 1.95942 20.6667 2.66667 20.6667Z",
    fill: "#20478B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1900_45944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinentEuropeCountrynetherland);
export default __webpack_public_path__ + "static/media/Continent=Europe, Country=netherland.6da4994a1d053c5d4bd2a3dc3d8d3fa3.svg";
export { ForwardRef as ReactComponent };